import { RequestStatus } from '../../../../models';
import { type MfaPromptState } from '../MfaPromptState';

const INITIAL_STATE: MfaPromptState = {
  isActive: false,
  onSuccessAction: undefined,
  availableFactorsStatus: RequestStatus.Idle,
  availableFactors: undefined,

  requestedUrl: undefined,
  requestedMethod: undefined,
  protectedUrlsStatus: RequestStatus.Idle,
  protectedUrls: undefined,
};

export default INITIAL_STATE;
